module.exports = __webpack_public_path__ + "static/media/19-min.8acc26ec.jpg";